import { J1LeftarrowD, J1RightarrowD } from '@e3dc-react/icons'
import { IconButton, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import { TotalMonths } from 'src/Libs/shop/utils/basic-system-fix-flex'
import { makeStyles } from 'tss-react/mui'

interface BasicSystemTablePaginationProps {
  pages: number[]
  currentPage: number
  lastPage: number
  totalMonths: TotalMonths[]
  onPageChange: (page: number) => void
}

const useStyles = makeStyles()(theme => ({
  paginationContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
}))

const BasicSystemTablePagination: React.FC<BasicSystemTablePaginationProps> = ({ pages, currentPage, lastPage, totalMonths, onPageChange }) => {
  const { classes } = useStyles()
  return (
    <Box className={classes.paginationContainer}>
      <IconButton
        disabled={currentPage <= 0}
        onClick={() => {
          onPageChange(currentPage - 1)
        }}
      >
        <J1LeftarrowD />
      </IconButton>

      {pages.map((page, index) => {
        const nextPage = index + 1

        return (
          <IconButton
            key={`${page}-${index}`}
            onClick={() => {
              onPageChange(index)
            }}
            disabled={index === currentPage}
          >
            <Typography>{nextPage}</Typography>
          </IconButton>
        )
      })}

      <IconButton
        disabled={lastPage >= totalMonths.length}
        onClick={() => {
          onPageChange(currentPage + 1)
        }}
      >
        <J1RightarrowD />
      </IconButton>
    </Box>
  )
}

export default BasicSystemTablePagination
